export default __webpack_public_path__ + "static/media/diamond-color-5@3x.79d91820.png";